<template>
  <v-dialog v-model="dialog" max-width="900px" persistent dark>
    <v-card style="background-color: #1e1e1e">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-h5 gold-text">Quiz Editor: {{ module ? module.title : '' }}</span>
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      
      <v-card-text>
        <div v-for="(q, qIndex) in questions" :key="qIndex" class="mb-6 pa-4 rounded-lg" style="background: rgba(255,255,255,0.05)">
          <div class="d-flex justify-space-between align-center mb-4">
            <v-text-field v-model="q.question" :label="`Frage ${qIndex + 1}`" outlined hide-details></v-text-field>
            <v-btn icon color="red" @click="removeQuestion(qIndex)" class="ml-4"><v-icon>mdi-delete</v-icon></v-btn>
          </div>
          
          <div class="pl-4">
            <div v-for="(opt, oIndex) in q.options" :key="oIndex" class="d-flex align-center mb-2">
              <v-checkbox v-model="opt.correct" color="success" hide-details class="mt-0 pt-0 mr-2"></v-checkbox>
              <v-text-field v-model="opt.text" label="Antwortmöglichkeit" outlined dense hide-details></v-text-field>
              <v-btn icon small color="grey" @click="removeOption(qIndex, oIndex)"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-btn small text color="#58d388" @click="addOption(qIndex)" class="mt-2">+ Option hinzufügen</v-btn>
          </div>
        </div>
        
        <v-btn block color="rgba(255,255,255,0.1)" class="white--text" @click="addQuestion">
          <v-icon left>mdi-plus</v-icon> Neue Frage hinzufügen
        </v-btn>
      </v-card-text>
      
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close">Abbrechen</v-btn>
        <v-btn color="#58d388" class="black--text" @click="saveQuiz" :loading="saving">Quiz Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api";

export default {
  name: "QuizEditor",
  props: {
    value: Boolean,
    module: Object
  },
  data() {
    return {
      questions: [],
      saving: false
    };
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  watch: {
    dialog(val) {
      if (val && this.module) {
        this.loadQuiz();
      }
    }
  },
  methods: {
    async loadQuiz() {
      try {
        const mod = await api.akademie.fetchModule(this.module._id || this.module.id);
        if (mod && mod.quiz && mod.quiz.questions) {
          this.questions = mod.quiz.questions;
        } else {
          this.questions = [{ question: "", options: [{ text: "", correct: false }] }];
        }
      } catch (e) {
        console.error(e);
      }
    },
    close() {
      this.dialog = false;
    },
    addQuestion() {
      this.questions.push({ question: "", options: [{ text: "", correct: false }] });
    },
    removeQuestion(qIndex) {
      this.questions.splice(qIndex, 1);
    },
    addOption(qIndex) {
      this.questions[qIndex].options.push({ text: "", correct: false });
    },
    removeOption(qIndex, oIndex) {
      this.questions[qIndex].options.splice(oIndex, 1);
    },
    async saveQuiz() {
      this.saving = true;
      try {
        await api.akademie.saveQuiz(this.module._id || this.module.id, { questions: this.questions });
        this.close();
      } catch (e) {
        console.error(e);
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.gold-text { color: #58d388 !important; }
</style>
